import styled from "styled-components";
import { Typography, Card } from "antd";

const { Text } = Typography;

export const StyledLogoCard = styled(Card)`
  width: 100%;
  cursor: pointer;

  .ant-card-body {
    padding: 0;
    height: 150px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const StyledWrapper = styled.div`
  align-items: center;
  height: 150px;
  width: 100%;
  justify-content: center;
  display: flex;
`;

export const StyledText = styled(Text)`
  padding-top: 0.1em;
`;
